export const SelectTheme = (theme:any) => ({
    ...theme,
    borderRadius: 7,
    border: '1px solid #ced4da',
    // colors: {
    //     ...theme.colors,
    //     primary: '#fd7e14',
    // },
})